<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-phoenix">
<h1>The Phoenix</h1>
<p style=" text-indent:1em;">With the self-infliction</p>
<p>Of the incendiary flames</p>
<p>To be the ashes</p>
<p>From self-immolation</p>
<p>Of the soul</p><br/>
<p>Black searing heat</p>
<p>Fusing agony</p>
<p>To a mind</p>
<p>That cannot break</p>
<p>Until the world crumbles</p><br/>
<p>Smoldering</p>
<p>Until your core implodes</p>
<p>The death of self</p>
<p>Surrendering of will</p><br/>
<p>To be molded</p>
<p>With your very own hands</p>
<p>To be the bird</p>
<p>Of your imagination</p><br/>
<p>Only if you are willing to die</p>
<p>Will you fly high</p>
<p>To the infinite pinnacle</p>
<p>Of the phoenix.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?cfd08fc0